const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const isShopifyThemeEditor =
  window.Shopify?.designMode === true;

document.documentElement.classList.toggle(
  'shopify-theme-editor',
  isShopifyThemeEditor
);

gsap.registerPlugin(ScrollTrigger);

if (!isMobile && !isShopifyThemeEditor) {
  const lenisUrl = document.querySelector('[data-lenis-src]').dataset.lenisSrc
  const { default: Lenis } = await import(lenisUrl)

  const lenis_instance = new Lenis({
    prevent: () => isMobile, // disabilitato su mobile
  })
  // Expose the Lenis instance so non-module scripts (e.g. the PDP thumbnail
  // scroll handler in sections/product-information.liquid) can drive the scroll
  // through Lenis instead of fighting it with window.scrollTo().
  // NB: Lenis itself sets window.lenis to a plain metadata object, so we use a
  // distinct name for the actual instance.
  window.lenisInstance = lenis_instance
  lenis_instance.on('scroll', ScrollTrigger.update)

  gsap.ticker.add((time) => {
    lenis_instance.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0);
}

// Stop/start di Lenis quando si apre/chiude un drawer overlay (menu / cart / search)
document.addEventListener('toggle', (e) => {
  const t = e.target;
  if (!(t instanceof HTMLDetailsElement)) return;

  // limita ai drawer che prendono il viewport (menu, cart, search)
  const isOverlayDrawer = t.matches(
    '#Details-menu-drawer-container, cart-drawer-component dialog, predictive-search details, [class*="menu-drawer"]'
  );
  if (!isOverlayDrawer) return;

  if (t.open) {
    window.lenisInstance?.stop();
  } else {
    // riprendi solo se nessun altro drawer è ancora aperto
    const stillOpen = document.querySelector(
      '#Details-menu-drawer-container[open], cart-drawer-component dialog[open], predictive-search details[open]'
    );
    if (!stillOpen) window.lenisInstance?.start();
  }
}, true);


const REVEAL_DURATION = 1.15;
const REVEAL_EASE = "expo.out";
const REVEAL_STAGGER = 0.06;

const snippets = {
  promotedProductsDragScroll() {
    document.querySelectorAll('.wrapper_promoted_products').forEach((slider) => {
      if (slider.dataset.dragScrollReady === 'true') return;
      slider.dataset.dragScrollReady = 'true';

      let isDown = false;
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      let moved = 0;

      const DRAG_THRESHOLD = 6;

      function getX(e) {
        return e.pageX ?? e.clientX ?? 0;
      }

      slider.addEventListener('pointerdown', (e) => {
        // Solo mouse / pen. Il touch nativo resta gestito dal browser.
        if (e.pointerType === 'touch') return;

        isDown = true;
        isDragging = false;
        moved = 0;

        startX = getX(e);
        scrollLeft = slider.scrollLeft;

        slider.classList.add('is-dragging');
        slider.setPointerCapture?.(e.pointerId);
      });

      slider.addEventListener('pointermove', (e) => {
        if (!isDown) return;

        const x = getX(e);
        const walk = x - startX;
        moved = Math.max(moved, Math.abs(walk));

        if (moved > DRAG_THRESHOLD) {
          isDragging = true;
          e.preventDefault();
          slider.scrollLeft = scrollLeft - walk;
        }
      });

      function endDrag(e) {
        if (!isDown) return;

        isDown = false;
        slider.classList.remove('is-dragging');

        try {
          slider.releasePointerCapture?.(e.pointerId);
        } catch (_) {}

        // Reset dopo il click event, così possiamo bloccare il click se era drag
        setTimeout(() => {
          isDragging = false;
          moved = 0;
        }, 0);
      }

      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
      slider.addEventListener('pointerleave', endDrag);

      // Evita che dopo il drag si apra il link della card
      slider.addEventListener(
        'click',
        (e) => {
          if (moved > DRAG_THRESHOLD || isDragging) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      // Evita il drag nativo delle immagini
      slider.querySelectorAll('img, a').forEach((el) => {
        el.setAttribute('draggable', 'false');
      });
    });
  },

  //landing e home
  logoAnimation() {
    var logo_landing = document.querySelector('.logo_landing');
    if (!logo_landing) return;

    // wrapper logo sticky visibile in alto
    const logo_sticked_wrapper = document.createElement('a');
    logo_sticked_wrapper.href = '/';
    logo_sticked_wrapper.className = 'logo_sticked_wrapper';
    logo_sticked_wrapper.style.pointerEvents = 'none';
    logo_sticked_wrapper.setAttribute('aria-label', 'Home');
    document.querySelector('main#MainContent').after(logo_sticked_wrapper);

    // logo sticky visibile in alto (clone dell'originale)
    const logo_sticked = logo_landing.cloneNode(true);
    logo_sticked.classList.remove('logo_landing');
    logo_sticked.classList.add('logo_sticked');

    gsap.set(logo_sticked, { scale: 1, transformOrigin: 'bottom center' });

    logo_sticked_wrapper.appendChild(logo_sticked);

    // nascondi logo principale
    gsap.set(logo_landing, { opacity: 0 });

    // funzione che crea (o ricrea) la timeline principale
    let positionTimeline;
    const createPositionTimeline = () => {
      if (positionTimeline) {
        positionTimeline.scrollTrigger?.kill();
        positionTimeline.kill();
      }

      const logo_landing_bcr = logo_landing.getBoundingClientRect();
      const logo_landing_offset_top = logo_landing_bcr.top + window.scrollY;
      const logo_landing_width = logo_landing_bcr.width;
      const logo_landing_height = logo_landing_bcr.height;
      const target_width = window.innerWidth >= 1920 ? 186 : 140;
      const scale_factor = logo_landing_width / target_width;
      const final_height = logo_landing_height / scale_factor;
      const offset_initial_final_height = logo_landing_height - final_height;

      const marquee_el = document.querySelector('.header_marquee');
      const marquee_height = marquee_el ? marquee_el.getBoundingClientRect().height : 0;

      gsap.set(logo_sticked_wrapper, { y: logo_landing_offset_top, scale: 1, transformOrigin: 'bottom center' });
      gsap.set(logo_sticked, { scale: 1, transformOrigin: 'bottom center' });

      positionTimeline = gsap.timeline({
        scrollTrigger: {
          // start/end come posizioni assolute di scroll (px), non come stringa
          // relativa al trigger: quest'ultima viene riconvertita da GSAP usando
          // la sua lettura interna dello scroll corrente, che con Lenis può
          // essere leggermente sfasata rispetto a window.scrollY nel momento
          // esatto in cui la timeline viene ricreata (es. dopo un resize a
          // pagina scrollata) — risultato: boundary sbagliati e animazione
          // "a metà strada". Con numeri assoluti non c'è nulla da riconvertire.
          start: 0,
          end: logo_landing_offset_top,
          scrub: true,
        }
      }).to(logo_sticked_wrapper, {
        scale: 1 / scale_factor,
        transformOrigin: 'bottom center',
        y: 20 - offset_initial_final_height + marquee_height,
        ease: 'linear'
      });
    };

    // chiamata iniziale
    createPositionTimeline();


    var headerSection = document.querySelector('header.header-section');
    if(window.scrollY < window.innerHeight)
      headerSection.classList.add('whiteize');

    // funzione che crea (o ricrea) i trigger colore, con start/end come
    // posizioni assolute di scroll (px) calcolate da bcr + scrollY corrente,
    // stesso principio della timeline di posizione: niente stringhe relative
    // al trigger ('top top+=Npx') da far riconvertire a GSAP, che è proprio
    // il punto in cui poteva insinuarsi lo sfasamento post-resize.
    let colorTriggers = [];
    const createColorTriggers = () => {
      colorTriggers.forEach((st) => st.kill());
      colorTriggers = [];

      // header testi bianchi dentro hero in alto
      const hero_container = document.querySelector('.hero__container');
      if (hero_container) {
        const hero_bottom_abs = hero_container.getBoundingClientRect().bottom + window.scrollY;
        colorTriggers.push(ScrollTrigger.create({
          start: hero_bottom_abs,
          end: hero_bottom_abs - 100,
          onEnter: () => {
            gsap.to(logo_sticked, { color: '#000', pointerEvents: 'auto', duration: .25 });
            logo_sticked_wrapper.style.pointerEvents = 'auto';
            headerSection.classList.remove('whiteize');
          },
          onLeaveBack: () => {
            gsap.to(logo_sticked, { color: '#F6F3E1', pointerEvents: 'none', duration: .25 });
            logo_sticked_wrapper.style.pointerEvents = 'none';
            headerSection.classList.add('whiteize');
          }
        }));
      }

      // header testi bianchi dentro sezioni con class "header_inverted_colors"
      document.querySelectorAll('.header_inverted_colors').forEach((hic) => {
        const hic_bcr = hic.getBoundingClientRect();
        const hic_top_abs = hic_bcr.top + window.scrollY;
        const hic_bottom_abs = hic_bcr.bottom + window.scrollY;
        colorTriggers.push(ScrollTrigger.create({
          start: hic_top_abs - 40,
          end: hic_bottom_abs,
          onEnter: () => {
            gsap.to(logo_sticked, { color: '#F6F3E1', pointerEvents: 'none', duration: .25 });
            headerSection.classList.add('whiteize');
          },
          onEnterBack: () => {
            gsap.to(logo_sticked, { color: '#F6F3E1', pointerEvents: 'none', duration: .25 });
            headerSection.classList.add('whiteize');
          },
          onLeaveBack: () => {
            gsap.to(logo_sticked, { color: '#000', pointerEvents: 'auto', duration: .25 });
            headerSection.classList.remove('whiteize');
          },
          onLeave: () => {
            gsap.to(logo_sticked, { color: '#000', pointerEvents: 'auto', duration: .25 });
            headerSection.classList.remove('whiteize');
          }
        }));
      });

      // header testi bianchi dentro footer
      const footer_el = document.querySelector('footer');
      if (footer_el) {
        const footer_bcr = footer_el.getBoundingClientRect();
        const footer_top_abs = footer_bcr.top + window.scrollY;
        const footer_bottom_abs = footer_bcr.bottom + window.scrollY;
        colorTriggers.push(ScrollTrigger.create({
          start: footer_top_abs - 40,
          end: footer_bottom_abs,
          onEnter: () => {
            gsap.to(logo_sticked, { color: '#F6F3E1', duration: .25 });
            headerSection.classList.add('whiteize');
          },
          onLeaveBack: () => {
            gsap.to(logo_sticked, { color: '#000', duration: .25 });
            headerSection.classList.remove('whiteize');
          }
        }));
      }
    };

    // chiamata iniziale
    createColorTriggers();

    // gestione resize con debounce 500ms
    let resizeTimer;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        createPositionTimeline();
        createColorTriggers();
        // stableRefresh() per tutti gli altri ScrollTrigger della pagina non
        // gestiti qui (risincronizza comunque Lenis su window.scrollY prima
        // del refresh globale).
        stableRefresh();
      }, 500);
    });
    window.addEventListener('marquee:closed', () => {
      createPositionTimeline();
      createColorTriggers();
      stableRefresh();
    });
  },

  // height marquee
  marqueeHeightVar() {
    const marquee_el = document.querySelector('.header_marquee');

    const updateMarqueeHeightVar = () => {
      // se l'elemento non esiste o è stato chiuso/nascosto, altezza = 0
      const is_visible = marquee_el
        && marquee_el.style.display !== 'none'
        && !marquee_el.classList.contains('marquee-block-wrapper--closed');

      const marquee_height = is_visible ? marquee_el.getBoundingClientRect().height : 0;

      document.documentElement.style.setProperty('--marquee-height', marquee_height + 'px');
      document.documentElement.classList.toggle('has-marquee', marquee_height > 0);
    };

    // chiamata iniziale
    updateMarqueeHeightVar();

    // resize con debounce 500ms, stesso timing usato altrove nel modulo
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateMarqueeHeightVar, 500);
    });

    // aggiornamento immediato alla chiusura della marquee (evento già
    // dispatchato dal blocco header_marquee al termine della transizione)
    window.addEventListener('marquee:closed', updateMarqueeHeightVar);

    // ResizeObserver per catturare variazioni dinamiche di altezza (wrap
    // testo, font caricati, ecc.) senza aspettare un resize della finestra
    if (marquee_el && window.ResizeObserver) {
      const observer = new ResizeObserver(updateMarqueeHeightVar);
      observer.observe(marquee_el);
    }
  },

  //INVERSE HEADER COLORS su sezioni con classe "header_inverted_colors" per tutte le pagine tranne landing e home
  //tldr; l'header in queste due pagine (landing e home) è diverso rispetto alle pagine del resto del sito; le animazioni sono gestite in modo diverso
  headerColorInversion() {
    var main = document.querySelector('main#MainContent');
    if(main.dataset.template == 'index' || main.dataset.template == 'page.homepage-alternativa')
      return; //salta se è home (landing) o homepage-alternativa
    
    //menu navigazione
    var nav = document.querySelector('header nav.menu-list');
    
    //logo
    var logo_dark = document.querySelector('.header__column .header-logo__image-container img.header-logo__image');
    var logo_light = document.querySelector('.header__column .header-logo__image-container img.logo-image-inverse');

    //account link e carrello
    var account_element = document.querySelector('.header__column .account-button.header-actions__action');

    //per controllo colori navmenu e account
    var headerSection = document.querySelector('header.header-section');
    // if(window.scrollY < window.innerHeight)
    //   headerSection.classList.add('whiteize');

    // tutte le sezioni con class "header_inverted_colors"
    document.querySelectorAll('.header_inverted_colors').forEach((hic) => {
      ScrollTrigger.create({
        trigger: hic,
        start: 'top-=40px top',
        end: 'bottom top',
        onEnter: () => {
          gsap.to(logo_dark, { opacity: 0, duration: .25 });
          gsap.to(logo_light, { opacity: 1, duration: .25 });
          headerSection.classList.add('whiteize');
        },
        onEnterBack: () => {
          gsap.to(logo_dark, { opacity: 0, duration: .25 });
          gsap.to(logo_light, { opacity: 1, duration: .25 });
          headerSection.classList.add('whiteize');
        },
        onLeaveBack: () => {
          gsap.to(logo_light, { opacity: 0, duration: .25 });
          gsap.to(logo_dark, { opacity: 1, duration: .25 });
          headerSection.classList.remove('whiteize');
        },
        onLeave: () => {
          gsap.to(logo_light, { opacity: 0, duration: .25 });
          gsap.to(logo_dark, { opacity: 1, duration: .25 });
          headerSection.classList.remove('whiteize');
        }
      });
    })
    
    // footer
    ScrollTrigger.create({
      trigger: 'footer',
      start: 'top-=40px top',
      end: 'bottom top',
      onEnter: () => {
        gsap.to(logo_dark, { opacity: 0, duration: .25 });
        gsap.to(logo_light, { opacity: 1, duration: .25 });
        headerSection.classList.add('whiteize');
      },
      onLeaveBack: () => {
        gsap.to(logo_light, { opacity: 0, duration: .25 });
        gsap.to(logo_dark, { opacity: 1, duration: .25 });
        headerSection.classList.remove('whiteize');
      }
    });
  },

  bigClaimRevealAnimation() { //es: About - Syncretic Beauty is a creative...
    document.querySelectorAll('.wrapper_big_claim').forEach((wbc) => {
      gsap.set(wbc, { display: 'block' })
      let pre_big_claim = wbc.querySelector('.pre_big_claim');

      //gsap.set(wbc.querySelectorAll('h2'), { textWrap: 'auto'}); //fix a capo

      //caratteri per indentazione (restano nel markup: onSplit li ripulisce a ogni (ri)split)
      let firstH2 = wbc.querySelector('h2');
      firstH2.innerHTML = '_________' + firstH2.innerHTML;

      // autoSplit: true fa sì che SplitText rifaccia lo split (con revert di
      // quello precedente) quando il resize cambia gli a-capo delle righe —
      // altrimenti le "lines" restano quelle spezzate sulla larghezza vecchia
      // e il testo risulta rotto/sovrapposto dopo un resize.
      SplitText.create(wbc.querySelectorAll('h2'), {
        type: "lines",
        mask: "lines",
        autoSplit: true,
        onSplit(self) {
          //sostituisci caratteri per indentazione con padding
          self.lines[0].textContent = self.lines[0].textContent.replace('_________', '');
          gsap.set(self.lines[0], { paddingLeft: 'var(--big-claim-indent)' });
          gsap.set(self.lines, { lineHeight: 1.2, marginBottom: '-0.2em' });

          let bc_section_wrapper = wbc.closest('.section-wrapper');

          // Se il reveal era già avvenuto prima del resize, non replicare
          // l'animazione da capo (si vedrebbe un flash): le righe ri-splittate
          // vengono semplicemente portate allo stato finale visibile.
          if (wbc.dataset.revealed === 'true') {
            gsap.set(wbc, { opacity: 1 });
            gsap.set(pre_big_claim, { opacity: 1 });
            gsap.set(self.lines, { yPercent: 0 });
            return;
          }

          let bc_tl = gsap.timeline({
            scrollTrigger: {
              trigger: wbc,
              start: "top 80%",
              toggleActions: "play none none none"
            },
            onStart: () => { wbc.dataset.revealed = 'true'; }
          })
            .set(wbc, { opacity: 1})
            .from(pre_big_claim, { opacity: 0, duration: .4, ease: 'power2.out' })
            .from(self.lines, {
              yPercent: 110,
              duration: 1.15,
              ease: "expo.out",
              stagger: {
                each: 0.06,
                ease: 'power2.inOut'
              }
            })

          //setta istanza tl a wrapper per concatenare eventuali animazioni nella stessa sezione
          if(bc_section_wrapper) {
            bc_section_wrapper.bc_tl = bc_tl;
            bc_section_wrapper.bc_tl_duration = bc_tl.duration();
          }

          // ritornandola, al prossimo resplit SplitText la revert-a (kill +
          // pulizia) prima di ricrearla: evita ScrollTrigger duplicati.
          return bc_tl;
        }
      });
    })
  },

  smallClaimRevealAnimation() { //es: Luxury beauty has become...
    document.querySelectorAll('.text_under_claim p').forEach((tucp,i) => {

      // compensazione primo carattere grande
      if(i == 0)
        tucp.innerHTML = '__' + tucp.innerHTML;

      // stesso principio di bigClaimRevealAnimation: autoSplit ri-splitta le
      // righe al resize invece di lasciarle "congelate" sulla larghezza vecchia.
      SplitText.create(tucp, {
        type: "lines",
        mask: "lines",
        autoSplit: true,
        onSplit(self) {
          // rimossa compensazione primo carattere grande
          if(i == 0)
            self.lines[0].textContent = self.lines[0].textContent.replace('__', '');

          // già rivelato prima del resize: nessun replay, solo stato finale
          if (tucp.dataset.revealed === 'true') {
            gsap.set(tucp, { opacity: 1 });
            gsap.set(self.lines, { yPercent: 0 });
            return;
          }

          let tucp_tl;

          //se esiste usa istanza tl nel wrapper per concatenare alle eventuali animazioni nella stessa sezione
          let tucp_section_wrapper = tucp.closest('.section-wrapper');
          if(tucp_section_wrapper && tucp_section_wrapper.bc_tl) {
            tucp_tl = tucp_section_wrapper.bc_tl
          }else{
            tucp_tl = gsap.timeline({
              scrollTrigger: {
                trigger: tucp,
                start: "top 80%",
                toggleActions: "play none none none"
              }
            })
          }

          tucp.style.opacity = 1;

          let atPosition = tucp_section_wrapper?.bc_tl_duration ? tucp_section_wrapper.bc_tl_duration : '>';

          tucp_tl
            .set(tucp, { opacity: 1 }, atPosition)
            .from(self.lines, {
              yPercent: 110,
              duration: REVEAL_DURATION,
              ease: REVEAL_EASE,
              stagger: REVEAL_STAGGER,
              onStart: () => { tucp.dataset.revealed = 'true'; }
            }, atPosition);

          // Se tucp_tl è la timeline CONDIVISA del big claim (bc_tl), non la
          // ritorniamo: il suo ciclo di vita (revert su resplit) è già
          // gestito da bigClaimRevealAnimation, e SplitText qui reverterebbe
          // anche la parte del big claim se gliela restituissimo.
          return (tucp_section_wrapper && tucp_section_wrapper.bc_tl === tucp_tl) ? undefined : tucp_tl;
        }
      });
    })
  },

  smallClaimRevealAnimationALTERNATIVE() { //per casi specifici
    document.querySelectorAll('.text_under_claim_ALT p').forEach((tucp,i) => {

      // compensazione primo carattere grande
      if(i == 0)
        tucp.innerHTML = '__' + tucp.innerHTML;

      let tucp_st = new SplitText(tucp, { type: "lines", mask: "lines" });

      // rimossa compensazione primo carattere grande
      if(i == 0)
        tucp_st.lines[0].textContent = tucp_st.lines[0].textContent.replace('__', '');
      
      let tucp_tl;
      
      //se esiste usa istanza tl nel wrapper per concatenare alle eventuali animazioni nella stessa sezione
      let tucp_section_wrapper = tucp.closest('.section-wrapper, .content_perfumer');
      let isGroupBlock = tucp_section_wrapper && tucp_section_wrapper.classList.contains('content_perfumer');
      if(tucp_section_wrapper && tucp_section_wrapper.bc_tl) {
        tucp_tl = tucp_section_wrapper.bc_tl
      }else{
        tucp_tl = gsap.timeline({ 
          scrollTrigger: {
            trigger: tucp,
            start: isGroupBlock ? "top 75%" : "top 90%",
            toggleActions: "play none none none"
          }
        })
      }

      tucp_tl
        .set(tucp, { opacity: 1 }, tucp_section_wrapper.bc_tl_duration ? tucp_section_wrapper.bc_tl_duration / 2 : '>')
        .from(tucp_st.lines, { 
          yPercent: 110,
          duration: REVEAL_DURATION,
          ease: REVEAL_EASE,
          stagger: REVEAL_STAGGER
        }, tucp_section_wrapper.bc_tl_duration ? tucp_section_wrapper.bc_tl_duration / 2 : '>');
    })
  },

  bigTitleReveal(){ //es: The Radio o Discover QSL CARDS
    document.querySelectorAll('.big_title').forEach((big_title) => {
      let big_title_Hs = big_title.querySelectorAll(".text-block h1, .text-block h2, .text-block h3");
      gsap.set('.big_title .text-block', { overflow: 'hidden' });

      var is_delayed = big_title.classList.contains('big_title--delayed');

      let big_title_tl = gsap.timeline({
        scrollTrigger: { trigger: big_title, start: is_delayed ? "top 60%" : "top 80%", toggleActions: "play none none none" }
      })
        .set(big_title, { opacity: 1 })
         .from(big_title_Hs, { 
          yPercent: 110,
          duration: REVEAL_DURATION,
          ease: REVEAL_EASE,
          stagger: REVEAL_STAGGER,
        })
        
      //se presente anche paragraphs di seguito concatena l'animazione
      let big_paragraphs = big_title.closest('.section-wrapper').querySelectorAll('.big_paragraph p');
      if(big_paragraphs.length > 0) {

        // compensazione primo carattere grande
        big_paragraphs[0].innerHTML = '__' + big_paragraphs[0].innerHTML;

        let bp_st = new SplitText(big_paragraphs, { type: "lines", mask: "lines" });

        // rimossa compensazione primo carattere grande
        bp_st.lines[0].textContent = bp_st.lines[0].textContent.replace('__', '');


        // big_title_tl
        gsap.timeline({
          scrollTrigger: { trigger: big_title, start: is_delayed ? "top 50%" : "top 65%", toggleActions: "play none none none" }
        })
          .set(big_paragraphs, { opacity: 1 })
          .from(bp_st.lines, {
            yPercent: 110,
            duration: 1.5,
            ease: REVEAL_EASE,
            stagger: REVEAL_STAGGER,
          });
      }
      

      //setta istanza tl a wrapper per concatenare eventuali animazioni nella stessa sezione
      let bt_section_wrapper = big_title.closest('.section-wrapper');
      if(bt_section_wrapper) {
        bt_section_wrapper.bt_tl = big_title_tl;
        bt_section_wrapper.bt_tl_duration = big_title_tl.duration();
      }
    })
  },

  text_reveal_animation() { //stessa animazione dei "big_paragraph ma non dipendente dalla prensenza di big title"
    document.querySelectorAll('.text_reaveal_animation').forEach((tra_wrapper) => {
      let tra_par = tra_wrapper.querySelectorAll('p');
      // compensazione primo carattere grande
      tra_par[0].innerHTML = '__' + tra_par[0].innerHTML;

      let tra_par_st = new SplitText(tra_par, { type: "lines", mask: "lines" });

      // rimossa compensazione primo carattere grande
      tra_par_st.lines[0].textContent = tra_par_st.lines[0].textContent.replace('__', '');


      gsap.timeline({
        scrollTrigger: { trigger: tra_wrapper, start: "top 90%", toggleActions: "play none none none" }
      })
        .set(tra_par, { opacity: 1 })
        .from(tra_par_st.lines, { yPercent: 110,
          duration: REVEAL_DURATION,
          ease: REVEAL_EASE,
          stagger: REVEAL_STAGGER,
        });
    })

  },

  /* landManParallax() {
    const section = document.querySelector('.section_land_man');
    if (!section) return;

    const bgImage = section.querySelector('.background-image-container img');
    const fgImage = section.querySelector('.image-block__image');
    if (!bgImage || !fgImage) return;

    gsap.fromTo(bgImage, { yPercent: -4 }, {
      yPercent: 10, ease: 'none',
      scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
    });

    const mm = gsap.matchMedia();
    mm.add("(min-width: 768px)", () => {
      gsap.fromTo(fgImage, { yPercent: -8 }, {
        yPercent: 15, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
      return () => {};
    });
    mm.add("(max-width: 767px)", () => {
      gsap.fromTo(fgImage, { yPercent: -8 }, {
        yPercent: 10, ease: 'none',
        scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
      });
      return () => {};
    });
  }, */

  radioImageParallax() {
    const radio_image = document.querySelector('.radio_asset');
    if (!radio_image) return;

    const radio_image_section = radio_image.closest('div.section');
    gsap.fromTo(radio_image, { yPercent: -5 }, {
      yPercent: 3, ease: 'none',
      scrollTrigger: { trigger: radio_image_section, start: 'top bottom', end: 'top 20%', scrub: true }
    });
  },
  cloudsImageParallax() {
    //nuvole ed elementi su cielo azzurro
    let clouds_image = document.querySelector('.clouds_asset');
    if (!clouds_image) return;

    let clouds_image_section = clouds_image.closest('div.section');
    gsap.fromTo(clouds_image, { yPercent: 0 }, {
      yPercent: 9, ease: 'none',
      scrollTrigger: { trigger: clouds_image_section, start: 'top bottom', end: 'bottom top', scrub: true }
    });

    //nuvole in basso
    let game_bottom_clouds_image_container = document.querySelector('.group-block:has(.game_bottom_clouds) > .group-block__media-wrapper .background-image-container');
    if (!game_bottom_clouds_image_container) return;
    let gbc_img = document.querySelector('.group-block:has(.game_bottom_clouds) > .group-block__media-wrapper .background-image-container');

    gsap.fromTo(gbc_img, { yPercent: 0 }, {
      yPercent: 28, ease: 'none',
      scrollTrigger: { trigger: game_bottom_clouds_image_container, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  },

  pdpTerrainSceneScrollParallax() {
    const section = document.querySelector('.terrain');
    if (!section) return;

    const clouds     = section.querySelector('.clouds_pdp');
    const clouds_img = clouds?.querySelector('.image-block__image');
    const clouds_sb      = section.querySelector('.clouds_syncretic_beauty');
    const clouds_sb_img  = clouds_sb?.querySelector('.image-block__image');
    const globe      = section.querySelector('.background-image-container img');

    const scrollOpts = {
      trigger: section,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      invalidateOnRefresh: true,
    };

    if (clouds && clouds_img) {
      gsap.set(clouds, { overflow: 'hidden' });
      gsap.set(clouds_img, { scale: 1.18, transformOrigin: '50% 50%' });
      gsap.fromTo(clouds_img,
        { yPercent: -10 },
        { yPercent: 10, ease: 'none', scrollTrigger: { ...scrollOpts, trigger: clouds } }
      );
      if (!clouds_img.complete) {
        clouds_img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
      }
    }

    if (clouds_sb && clouds_sb_img) {
      gsap.set(clouds_sb, { overflow: 'hidden' });
      gsap.set(clouds_sb_img, { scale: 1.18, transformOrigin: '50% 50%' });
      gsap.fromTo(clouds_sb_img,
        { yPercent: -10 },
        { yPercent: 10, ease: 'none', scrollTrigger: { ...scrollOpts, trigger: clouds_sb } }
      );
      if (!clouds_sb_img.complete) {
        clouds_sb_img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
      }
    }

    if (globe) {
      gsap.fromTo(globe,
        { yPercent: -6 },
        { yPercent: 6, ease: 'none', scrollTrigger: scrollOpts }
      );
    }

    const bgState = { y: 0 };
    const applyBg = () => section.style.setProperty('--terrain-bg-y', `${bgState.y}px`);

    ScrollTrigger.create({
      ...scrollOpts,
      onUpdate: (self) => {
        const p = (self.progress - 0.5) * 2;
        bgState.y = p * 10;
        applyBg();
      },
    });

    ScrollTrigger.observe({
      target: section,
      type: 'scroll',
      onStopDelayedCall: null,
    });

    return () => {
      window.removeEventListener('resize', onResize);
      clearTimeout(resizeTimer);
    };
  },

  //parallasse su mouse
  pdpTerrainSceneMouseParallax() { 
    // // Scena PDP "Terrain": 3 layer in profondità (back → front):
    // //   1. BG image della section (back.webp) — via background-position + CSS vars
    // //   2. Globe — <img> dentro .background-image-container
    // //   3. Clouds — <img> dentro .clouds_pdp (con mix-blend multiply via CSS)
    // //
    // // Cursor parallax: le nuvole "draggano" oppositamente al cursore (effetto in
    // // primo piano). Globe e bg si muovono lievemente NELLA stessa direzione del
    // // cursore (cioè OPPOSTAMENTE alle nuvole) con ampiezza decrescente: dà
    // // sensazione di profondità senza eccedere.
    // //
    // // Scroll parallax: nuvole più forte, globe leggero. Sul bg si potrebbe
    // // aggiungere in futuro ma per ora resta fisso allo scroll.
    // const section = document.querySelector('.terrain');
    // if (!section) return;

    // const clouds = section.querySelector('.clouds_pdp');
    // const clouds_img = clouds?.querySelector('.image-block__image');
    // const globe = section.querySelector('.background-image-container img');

    // // --- Setup + scroll parallax ---
    // if (clouds && clouds_img) {
    //   gsap.set(clouds, { overflow: 'hidden' });
    //   gsap.set(clouds_img, { scale: 1.18, transformOrigin: '50% 50%' });
    //   gsap.fromTo(clouds_img, { yPercent: -10 }, {
    //     yPercent: 10, ease: 'none',
    //     scrollTrigger: { trigger: clouds, start: 'top bottom', end: 'bottom top', scrub: true, invalidateOnRefresh: true }
    //   });
    //   if (!clouds_img.complete) {
    //     clouds_img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    //   }
    // }
    // if (globe) {
    //   gsap.fromTo(globe, { yPercent: -3 }, {
    //     yPercent: 3, ease: 'none',
    //     scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true }
    //   });
    // }

    // // --- Cursor parallax ---
    // const cloudsXTo = clouds_img ? gsap.quickTo(clouds_img, 'x', { duration: 0.8, ease: 'power3.out' }) : null;
    // const cloudsYTo = clouds_img ? gsap.quickTo(clouds_img, 'y', { duration: 0.8, ease: 'power3.out' }) : null;
    // const globeXTo  = globe ? gsap.quickTo(globe, 'x', { duration: 1.1, ease: 'power3.out' }) : null;
    // const globeYTo  = globe ? gsap.quickTo(globe, 'y', { duration: 1.1, ease: 'power3.out' }) : null;

    // // BG via CSS vars (background-position offset). gsap.to su un proxy state
    // // così le tween successive da mousemove si "overwrite" senza queue.
    // const bgState = { x: 0, y: 0 };
    // const applyBg = () => {
    //   section.style.setProperty('--terrain-bg-x', `${bgState.x}px`);
    //   section.style.setProperty('--terrain-bg-y', `${bgState.y}px`);
    // };

    // // Ampiezze (px). Decrescenti per profondità.
    // const CLOUDS_AMP = 28;
    // const GLOBE_AMP  = 14;
    // const BG_AMP     = 6;

    // section.addEventListener('mousemove', (e) => {
    //   const rect = section.getBoundingClientRect();
    //   const nx = (e.clientX - rect.left) / rect.width  - 0.5; // -0.5 .. 0.5
    //   const ny = (e.clientY - rect.top)  / rect.height - 0.5;

    //   // Nuvole + Globe: "drag" oppositamente al cursore (effetto in primo
    //   // piano per le nuvole, più lieve per il globe).
    //   cloudsXTo?.(-nx * CLOUDS_AMP);
    //   cloudsYTo?.(-ny * CLOUDS_AMP);
    //   globeXTo?.(-nx * GLOBE_AMP);
    //   globeYTo?.(-ny * GLOBE_AMP);
    //   // BG: accompagna il cursore (= opposto al globe), molto lieve
    //   gsap.to(bgState, {
    //     x: nx * BG_AMP, y: ny * BG_AMP,
    //     duration: 1.5, ease: 'power3.out', onUpdate: applyBg, overwrite: true,
    //   });
    // });

    // section.addEventListener('mouseleave', () => {
    //   cloudsXTo?.(0); cloudsYTo?.(0);
    //   globeXTo?.(0); globeYTo?.(0);
    //   gsap.to(bgState, { x: 0, y: 0, duration: 1.5, ease: 'power3.out', onUpdate: applyBg, overwrite: true });
    // });
  },

  discoverReveal() {
    const stackEl = document.querySelector('.stacked-cards__stack');
    if (!stackEl) return;

    gsap.set('.stacked-cards__stack', { zIndex: 10 });

    const co_section = document.querySelector('.section-carousel-osmo');
    if (!co_section) return;

    gsap.timeline({
      scrollTrigger: {
        trigger: co_section,
        start: "top 90%",
      }
    })
      .from('.stack-cards__card', { y: 180, duration: 1.5, ease: REVEAL_EASE, stagger: .1 });
  },

  screenParallax() {
    const screen_image = document.querySelector('.tv_asset');
    if (!screen_image) return;

    const screen_image_section = screen_image.closest('div.group-block-content');
    gsap.fromTo(screen_image, { yPercent: -4 }, {
      yPercent: 2, ease: 'none',
      scrollTrigger: { trigger: screen_image_section, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  },

  gameDescReveal() {
    const target = document.querySelector('.the_game_description p');
    if (!target) return;

    const game_desc_st = new SplitText('.the_game_description p', { type: "lines", mask: "lines" });
    gsap.from(game_desc_st.lines, {
      yPercent: 110, duration: 0.7, ease: "power3.out", stagger: .1,
      scrollTrigger: { trigger: '.the_game_description', start: "top 75%", toggleActions: "play none none none" }
    });
  },

  stickyVariantDropdownInit() {
    // Custom sticky variant dropdown su mobile: <details> con apertura verso
    // l'alto + aggiornamento della summary al cambio radio + chiusura al click
    // fuori (vedi sections/product-information.liquid).
    // I radio interni sono già wirati a variant-picker.js — qui ci occupiamo
    // solo dell'UX del wrapper details.
    document.querySelectorAll('.sticky-variant-dropdown').forEach((dropdown) => {
      const current = dropdown.querySelector('.sticky-variant-dropdown__current')
      if (!current) return

      // Aggiorna il testo summary quando una radio cambia + chiudi il details.
      dropdown.addEventListener('change', (e) => {
        const target = /** @type {HTMLInputElement} */ (e.target)
        if (target.tagName !== 'INPUT' || target.type !== 'radio') return
        const labelText = target.closest('.variant-option__button-label')
          ?.querySelector('.variant-option__button-label__text')
          ?.textContent?.trim()
        if (labelText) current.textContent = labelText
        // chiudi con piccolo delay così l'utente vede il check
        setTimeout(() => { dropdown.open = false }, 150)
      })

      // Chiudi al click fuori
      document.addEventListener('click', (e) => {
        if (!dropdown.open) return
        if (!dropdown.contains(/** @type {Node} */ (e.target))) {
          dropdown.open = false
        }
      })

      // Listener per variant:update (es. variante non disponibile) → resync summary
      document.addEventListener('variant:update', (e) => {
        const detail = /** @type {CustomEvent} */ (e).detail
        const variant = detail?.resource
        if (!variant) return
        const matching = dropdown.querySelector(`input[data-variant-id="${variant.id}"]`)
        const labelText = matching?.closest('.variant-option__button-label')
          ?.querySelector('.variant-option__button-label__text')
          ?.textContent?.trim()
        if (labelText) current.textContent = labelText
      })
    })
  },

  pdpPerfumerReveal() {
    document.querySelectorAll(".pdp_reveal").forEach((container) => {
      if (container.dataset.revealed) return
      container.dataset.revealed = "1"

      const paragraphs = container.querySelectorAll("p")
      if (!paragraphs.length) return

      // Cerca l'icona: dentro al container OPPURE come sibling diretto
      // (caso in cui pdp_reveal sia stato messo sul text-block invece che
      // sul gruppo padre)
      let icon = container.querySelector(".icon-block")
      if (!icon && container.parentElement) {
        icon = container.parentElement.querySelector(":scope > .icon-block")
      }

      // Sposta l'icona come primo figlio inline del primo <p>: così entra
      // nel flusso di testo e wrappa naturalmente con line 1.
      if (icon) {
        paragraphs[0].insertBefore(icon, paragraphs[0].firstChild)
        icon.classList.add("pdp_reveal_icon")
      }

      container.classList.add("is-ready")

      const st = new SplitText(paragraphs, { type: "lines", mask: "lines" })

      gsap.from(st.lines, {
        yPercent: 110,
        duration: REVEAL_DURATION,
        ease: REVEAL_EASE,
        stagger: REVEAL_STAGGER,
        scrollTrigger: {
          trigger: container,
          start: "top 90%",
          toggleActions: "play none none none",
        },
      })
    })
  },

  //animazione ingresso image_notes in PDP
  pdp_notes_image_animation() {
    const notes_image = document.getElementById('notes_image');

    if(!notes_image) return;

    gsap.timeline({
      scrollTrigger: {
        trigger: notes_image,
        start: 'top 75%'
      }
    })
      .from('#notes_image_top_line', { opacity: 0, duration: 1, ease: 'power2.inOut' })
      .from('#notes_image_top_text', { opacity: 0, x: -20, duration: 1, ease: 'expo.out' }, '<.2')
      
      .from('#notes_image_heart_line', { opacity: 0, duration: 1, ease: 'power2.inOut' }, '<.5')
      .from('#notes_image_heart_text', { opacity: 0, x: 20, duration: 1, ease: 'expo.out' }, '<.2')

      .from('#notes_image_base_line', { opacity: 0, duration: 1, ease: 'power2.inOut' }, '<.5')
      .from('#notes_image_base_text', { opacity: 0, x: -20, duration: 1, ease: 'expo.out' }, '<.2')
  },

  //parallax layer image_notes in PDP
  pdp_note_image_parallax(){
    let notes_image = document.getElementById('notes_image');
    if(!notes_image) return;

    document.querySelector('[data-images-notes-index="0"]').style.transform = "translate(0, calc(var(--offset-factor) * 20px))";
    document.querySelector('[data-images-notes-index="1"]').style.transform = "translate(0, calc(var(--offset-factor) * 80px))";
    document.querySelector('[data-images-notes-index="2"]').style.transform = "translate(0, calc(var(--offset-factor) * 160px))";

    gsap.fromTo(notes_image, { '--offset-factor' : 0 }, { '--offset-factor': 1, ease: 'none', scrollTrigger: { trigger: notes_image, start: 'top bottom', end: 'bottom top', scrub: true } })

  },

  emailSignup() {
    const email_signup_section = document.querySelector('.email_signup_section');
    if (!email_signup_section) return;

    const signup_bck_img = email_signup_section.querySelector('.background-image-container img');
    gsap.set(signup_bck_img, { scale: 1.1 });
    gsap.fromTo(signup_bck_img, { y: -80 }, {
      y: 80, ease: 'none',
      scrollTrigger: { trigger: email_signup_section, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  },

  footerParallax() {
    const footer = document.querySelector("footer");
    if (!footer) return;

    const utilities = footer.querySelector(".footer-utilities");

    if (footer._footerParallaxCleanup) {
      footer._footerParallaxCleanup();
    }

    ScrollTrigger.getById("footer-parallax")?.kill();

    let raf = null;

    const clamp = gsap.utils.clamp(0, 1);

    const render = () => {
      raf = null;


      const rect = footer.getBoundingClientRect();
      const footerHeight = Math.max(rect.height, 1);

      const progress = clamp(
        (window.innerHeight - rect.top) / footerHeight
      );

      const y = gsap.utils.interpolate(-20, 0, progress);
      const scale = gsap.utils.interpolate(1.08, 1, progress);

      footer.style.setProperty(
        "--footer-after-y",
        `${y}%`
      );

      footer.style.setProperty(
        "--footer-after-opacity",
        progress
      );

      footer.style.setProperty(
        "--footer-after-scale",
        scale
      );

      if (utilities) {
        gsap.set(utilities, {
          yPercent: gsap.utils.interpolate(
            -8,
            0,
            progress
          )
        });
      }
    };

    const update = () => {
      if (raf !== null) return;

      raf = requestAnimationFrame(render);
    };

    window.addEventListener(
      "scroll",
      update,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      update
    );

    let removeLenisListener = null;

    if (window.lenisInstance?.on) {
      removeLenisListener =
        window.lenisInstance.on("scroll", update);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(update);
    }

    const leafVideo = footer.querySelector(
      ".leaf_asset video"
    );

    if (leafVideo) {
      leafVideo.addEventListener(
        "loadedmetadata",
        update
      );
    }

    render();

    footer._footerParallaxCleanup = () => {
      window.removeEventListener(
        "scroll",
        update
      );

      window.removeEventListener(
        "resize",
        update
      );

      if (typeof removeLenisListener === "function") {
        removeLenisListener();
      }

      if (leafVideo) {
        leafVideo.removeEventListener(
          "loadedmetadata",
          update
        );
      }

      if (raf !== null) {
        cancelAnimationFrame(raf);
      }
    };
  },
  /* footerParallax() {
    const footer = document.querySelector("footer");
    if (!footer) return;

    const mainFooter = footer.querySelector(".shopify-section-group-footer-group:not(.footer-utilities)");
    const footerLogo = mainFooter?.querySelector('.icon-block');
    const utilities  = footer.querySelector(".footer-utilities");
    const leafAsset  = footer.querySelector(".shopify-section:has(.leaf_asset)");

    // Stato iniziale — GSAP è l'unico a toccare transform/opacity
    if (leafAsset) {
      gsap.set(leafAsset, {
        yPercent: -20,
        opacity: 0,
        scale: 1.08,
        transformOrigin: "bottom center"
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#MainContent",
        start: "bottom bottom",
        end: "bottom+=700px bottom",
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    if (footerLogo) {
      tl.fromTo(footerLogo,
        { yPercent: -150 },
        { yPercent: 0, ease: "power2.out", duration: .8 },
      0);
    }

    if (utilities) {
      tl.fromTo(utilities,
        { yPercent: -8 },
        { yPercent: 0, ease: "none" },
      0);
    }

    if (leafAsset) {
      tl.to(leafAsset, {
        yPercent: 0,
        opacity: 1,
        scale: 1,
        ease: "none",
        duration: 1
      }, 0);
    }
  }, */

  videoControls() {
    document.querySelectorAll('deferred-media').forEach((media) => {
      // --- Autoplay background videos (e.g. the .story video above) ---
      // The theme's DeferredMedia pauses every other deferred-media when one
      // starts playing — which otherwise leaves these decorative autoplay
      // loops stopped forever. Resume them whenever they get paused.
      if (media.hasAttribute('autoplay')) {
        const keepPlaying = () => {
          const v = media.querySelector('video');
          if (v && v.paused && !document.hidden) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          }
        };
        const watchAutoplay = (v) => {
          if (!v || v.dataset.keepPlayingBound) return;
          v.dataset.keepPlayingBound = 'true';
          v.addEventListener('pause', () => setTimeout(keepPlaying, 0));
        };
        watchAutoplay(media.querySelector('video'));
        new MutationObserver(() => watchAutoplay(media.querySelector('video'))).observe(media, {
          childList: true,
          subtree: true,
        });
        return;
      }

      const controls = media.querySelector('.custom-video-controls');
      if (!controls) return;

      const currentEl = controls.querySelector('.custom-video-current');
      const durationEl = controls.querySelector('.custom-video-duration');
      const progressFill = controls.querySelector('.custom-video-progress-fill');
      const liquidDuration = Number(durationEl.dataset.duration || 0);
      const posterButton = media.querySelector('.deferred-media__poster-button');

      function formatTime(seconds) {
        if (!Number.isFinite(seconds) || seconds <= 0) return '00:00';
        const m = Math.floor(seconds / 60);
        const s = Math.floor(seconds % 60);
        return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }

      if (liquidDuration > 0) durationEl.textContent = formatTime(liquidDuration);

      // The poster button doubles as the "Play" overlay. Before the first play
      // it shows the poster image + "Play"; afterwards the poster image stays
      // hidden, so toggling the overlay just fades the "Play" label in/out over
      // the (paused/ended) video frame — no poster swap, no flicker.
      let firstFrameShown = false;
      function setOverlay(visible) {
        if (!posterButton) return;
        posterButton.style.pointerEvents = visible ? 'auto' : 'none';
        gsap.to(posterButton, { opacity: visible ? 1 : 0, duration: 0.25, ease: 'power1.out' });

        // Mostra/nascondi i controls in modo inverso all'overlay
        if (firstFrameShown) {
          controls.style.pointerEvents = visible ? 'none' : 'auto';
          gsap.to(controls, { opacity: visible ? 0 : 1, duration: 0.25, ease: 'power1.out' });
        }
      }

      const getVideo = () => media.querySelector('video');

      function playVideo() {
        const video = getVideo();
        if (!video) return;
        if (video.ended) video.currentTime = 0;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
        setOverlay(false);
      }

      function pauseVideo() {
        const video = getVideo();
        if (!video) return;
        video.pause();
        setOverlay(true);
      }

      if (posterButton) {
        // First click: let the theme's showDeferredMedia load the video (the
        // reveal below hides the overlay once a real frame is painted).
        // Afterwards, the overlay click just resumes a paused/ended video.
        posterButton.addEventListener('click', () => {
          if (getVideo() && firstFrameShown) playVideo();
        });
      }

      function smoothRevealVideo(video) {
        if (!video || video.dataset.smoothRevealBound) return;
        video.dataset.smoothRevealBound = 'true';
        // requestVideoFrameCallback fires when a real frame is actually
        // composited — the definitive "the video is showing something" signal,
        // so the poster only hides once there's a frame behind it (no flicker).
        const reveal = () => {
          firstFrameShown = true;
          media.classList.add('is-video-ready');
          setOverlay(false);
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          video.addEventListener('loadeddata', reveal, { once: true });
          video.addEventListener('playing', reveal, { once: true });
        }
      }

      function bindVideo(video) {
        if (!video || video.dataset.customControlsBound) return;
        video.dataset.customControlsBound = 'true';

        // Must not loop, otherwise it never ends and the "Play" label can't
        // come back when the client expects it to.
        video.loop = false;

        function update() {
          currentEl.textContent = formatTime(video.currentTime);
          const realDuration = Number.isFinite(video.duration) && video.duration > 0
            ? video.duration : liquidDuration;
          if (realDuration > 0) durationEl.textContent = formatTime(realDuration);
          progressFill.style.width = `${realDuration ? (video.currentTime / realDuration) * 100 : 0}%`;
        }

        video.addEventListener('loadedmetadata', update);
        video.addEventListener('durationchange', update);
        video.addEventListener('timeupdate', update);
        update();

        // Click the video to pause it; bring the "Play" label back on pause
        // and on end (the video element stays put — no poster swap, no flicker).
        video.addEventListener('click', pauseVideo);
        video.addEventListener('ended', () => setOverlay(true));
      }

      const observer = new MutationObserver(() => {
        const video = getVideo();
        bindVideo(video);
        smoothRevealVideo(video);
      });
      observer.observe(media, { childList: true, subtree: true });

      const initialVideo = getVideo();
      bindVideo(initialVideo);
      smoothRevealVideo(initialVideo);
    });
  },

  scrollTriggerRefresh() {
    if (window.scrollY > 0) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (snippets._logoSetup) {
            snippets._logoSetup();
          } else {
            ScrollTrigger.refresh();
          }
        });
      });
    }
  },

  switchSpecialCharsStickyAddToCartCategory() {
    var sticky_add_to_cart_category = document.querySelector('.sticky-add-to-cart__category');
    if(sticky_add_to_cart_category)
      sticky_add_to_cart_category.innerHTML = sticky_add_to_cart_category.innerHTML.replace('Â', '&#194'); // o &Acirc;
  }

};

const THEME_EDITOR_DISABLED_ANIMATIONS = new Set([
  'logoAnimation',
  'headerColorInversion',
  'bigClaimRevealAnimation',
  'smallClaimRevealAnimation',
  'smallClaimRevealAnimationALTERNATIVE',
  'bigTitleReveal',
  'text_reveal_animation',
  'radioImageParallax',
  'cloudsImageParallax',
  'pdpTerrainSceneScrollParallax',
  'pdpTerrainSceneMouseParallax',
  'discoverReveal',
  'screenParallax',
  'gameDescReveal',
  'pdpPerfumerReveal',
  'pdp_notes_image_animation',
  'pdp_note_image_parallax',
  'emailSignup',
  'footerParallax',
  'scrollTriggerRefresh'
]);

function showThemeEditorContent(root = document) {
  if (!isShopifyThemeEditor) return;

  const scope =
    root && root.querySelectorAll
      ? root
      : document;

  if (scope.matches?.('.pdp_reveal')) {
    scope.classList.add('is-ready');
  }

  scope
    .querySelectorAll?.('.pdp_reveal')
    .forEach((element) => {
      element.classList.add('is-ready');
    });
}

function initAll() {
  if (isShopifyThemeEditor) {
    showThemeEditorContent();
  }

  for (const [name, fn] of Object.entries(snippets)) {
    if (
      isShopifyThemeEditor &&
      THEME_EDITOR_DISABLED_ANIMATIONS.has(name)
    ) {
      continue;
    }

    try {
      fn();
    } catch (e) {
      console.error(`[${name}]`, e);
    }
  }
}

function stableRefresh() {
  if (isShopifyThemeEditor) return;

  // Forza Lenis ad allinearsi alla posizione reale del browser
  if(!isMobile && window.lenisInstance)
    window.lenisInstance.scrollTo(window.scrollY, { immediate: true });

  ScrollTrigger.refresh();
}

if (document.readyState === 'complete') {
  initAll();
  stableRefresh();
} else {
  window.addEventListener('load', () => {
    initAll();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        stableRefresh();
      });
    });
  });
}

// // Safety net per lazy images / font swap che shiftano il layout dopo load
// const ro = new ResizeObserver(() => {
//   lenis_instance.scrollTo(window.scrollY, { immediate: true });
//   ScrollTrigger.refresh();
// });
// ro.observe(document.body);
// setTimeout(() => ro.disconnect(), 5000);

const mo = new MutationObserver((mutations) => {
  const relevant = mutations.some(m =>
    [...m.addedNodes].some(n =>
      n.nodeType === 1 && (
        n.matches?.('[data-section-type]') ||
        n.closest?.('[data-section-type]')
      )
    )
  );
  if (relevant && !isShopifyThemeEditor) {
    ScrollTrigger.refresh();
  }
});

mo.observe(document.body, { childList: true, subtree: true });

if (isShopifyThemeEditor) {
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      showThemeEditorContent(event.target);
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      showThemeEditorContent(event.target);
    }
  );
}


/* Snippet that hide the avatar account button */
function lockAccountScroll() {
  if (document.documentElement.classList.contains('account-popup-open')) return;

  const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

  document.documentElement.classList.add('account-popup-open');
  document.body.classList.add('account-popup-open');
  document.body.dataset.accountScrollY = String(scrollY);

  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';

  window.lenisInstance?.stop();
}

function unlockAccountScroll() {
  if (!document.documentElement.classList.contains('account-popup-open')) return;

  const scrollY = parseInt(document.body.dataset.accountScrollY || '0', 10);

  document.documentElement.classList.remove('account-popup-open');
  document.body.classList.remove('account-popup-open');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  delete document.body.dataset.accountScrollY;

  window.scrollTo(0, scrollY);

  const stillOpen = document.querySelector(
    '#Details-menu-drawer-container[open], cart-drawer details[open], predictive-search details[open]'
  );

  if (!stillOpen) {
    window.lenisInstance?.start();
  }
}

function isAnyAccountDialogOpen() {
  return Array.from(document.querySelectorAll('shopify-account')).some((el) => {
    const root = el.shadowRoot;
    if (!root) return false;

    return root.querySelector('.dialog[open], .dialog-modal[open], dialog[open]');
  });
}

function syncAccountScrollLock() {
  if (isAnyAccountDialogOpen()) {
    lockAccountScroll();
  } else {
    unlockAccountScroll();
  }
}

function patchLoginForm(accountShadowRoot) {
  const loginForm = accountShadowRoot.querySelector('shopify-login-form');
  if (!loginForm) return;

  function patchSubmitButton(root) {
    const submit = root.querySelector('.login-form__email-submit');
    if (!submit || submit.dataset.submitPatched) return;

    submit.removeAttribute('disabled');
    const svg = submit.querySelector('svg');
    if (svg) svg.remove();

    const label = document.createElement('span');
    label.className = 'account__submit-label';
    label.textContent = 'Submit';
    submit.prepend(label);

    submit.dataset.submitPatched = 'true';
  }

  const tryInject = () => {
    if (!loginForm.shadowRoot) return;

    patchSubmitButton(loginForm.shadowRoot);

    if (!loginForm.shadowRoot.querySelector('#login-form-custom-style')) {
      const style = document.createElement('style');
      style.id = 'login-form-custom-style';
      style.textContent = `
        .account__email-input,
        .login-form__email-input {
          padding: 0 !important;
          border: none !important;
          filter: none !important;
          height: auto !important;
          border-bottom: 1px solid black !important;
          border-radius: 0 !important;
          font-family: FormeGrotesque, sans-serif;
          font-size: 16px;
        }
        .account__email-label,
        .login-form__email-label {
          display: none !important;
        }
        .account__email-input::placeholder,
        .login-form__email-input::placeholder {
          color: #00000080 !important;
        }
        .account__email-submit,
        .login-form__email-submit {
          height: auto!important;
          top: 0!important;
          background: transparent!important;
        }
        .account__submit-label {
          font-family: FormeGrotesque, sans-serif;
          font-size: 14px;
          color: black;
          line-height: 18px;
        }
        .account__email-submit svg,
        .login-form__email-submit svg {
          display: none !important;
        }
        .account__email-submit::before,
        .login-form__email-submit::before {
          content: none !important;
        }
      `;
      loginForm.shadowRoot.appendChild(style);
    }

    if (!loginForm.__loginFormShadowObserver) {
      loginForm.__loginFormShadowObserver = new MutationObserver(() => {
        patchSubmitButton(loginForm.shadowRoot);
      });
      loginForm.__loginFormShadowObserver.observe(loginForm.shadowRoot, {
        childList: true,
        subtree: true
      });
    }
  };

  tryInject();

  if (!loginForm.__loginFormObserver) {
    loginForm.__loginFormObserver = new MutationObserver(tryInject);
    loginForm.__loginFormObserver.observe(loginForm, {
      childList: true,
      subtree: true
    });
  }
}

function patchShopifyAccount(el) {
  const isLoggedIn = el.dataset.loggedIn === 'true';

  function patchDialog(root) {
    /**
     * Sostituisce icona X con testo Close
     */
    const closeButton = root.querySelector('#close-button, .account__close');

    if (closeButton && !closeButton.dataset.closePatched) {
      closeButton.innerHTML = `
        <span class="account-close-label">Close</span>
      `;

      closeButton.setAttribute('aria-label', 'Close');
      closeButton.dataset.closePatched = 'true';
    }

    /**
     * Inietta HTML dentro Orders / Profile
     */
    root.querySelectorAll('.stack-inline .button').forEach((menuButton) => {
      if (menuButton.dataset.rollReady === 'true') return;

      const text = menuButton.textContent.trim();

      if (!text) return;

      menuButton.innerHTML = `
        <span class="cta-roll__label">
          <span class="cta-roll__text">${text}</span>
          <span class="cta-roll__text cta-roll__text--hover" aria-hidden="true">${text}</span>
        </span>
      `;

      menuButton.dataset.rollReady = 'true';
    });
  }

  function patchButton() {
    const root = el.shadowRoot;
    if (!root) return;

    /**
     * Questo deve girare sempre, anche se .account-button non esiste
     */
    patchDialog(root);
    patchLoginForm(root);

    const button = root.querySelector('.account-button');

    /**
     * Non fare return prima del patchDialog
     */
    if (button) {
      const avatar = button.querySelector('.account-button__avatar');
      if (avatar) avatar.style.setProperty('display', 'none', 'important');

      if (isLoggedIn && !button.querySelector('.account-custom-label')) {
        const label = document.createElement('span');
        label.className = 'account-custom-label';
        label.textContent = 'Account';
        button.appendChild(label);
      }
    }

    if (!root.querySelector('#account-custom-style')) {
      const style = document.createElement('style');
      style.id = 'account-custom-style';
      style.textContent = `
        .account-button {
          min-height: auto !important;
        }

        .account-custom-label {
          font-size: 16px;
          font-family: Louize, serif !important;
        }

        .dialog[open]::backdrop { 
          background-color: #692B11CC;
          background-image: var(--grain-url);
          background-repeat: repeat;
          background-blend-mode: hard-light;
        }

        .dialog {
          inset: 0 !important;
          height: fit-content !important;
          margin: auto !important;
          border-radius: 0 !important;
          width: auto !important;
          max-width: 400px !important;
        }

        .dialog::after {
          content: "";
          position: absolute;
          inset: 0;
          background-image: var(--grain-url);
          background-repeat: repeat;
          mix-blend-mode: hard-light;
          pointer-events: none;
          z-index: 999;
        }

        .account__content {
          margin-top: 8px!important;
          gap: 64px!important;
          padding-top: 0!important;
        }
        .account__email {
          margin-bottom: 40px !important;
        }
        .account__heading {
          font-size: 20px !important; 
          font-family: Louize, serif !important;
          text-transform: uppercase !important;
        }

        .account__close {
          min-height: auto !important;
          padding: 0 !important;
          background: transparent !important;
          border: 0 !important;
          color: currentColor !important;
          font-family: FormeGrotesque, sans-serif !important;
          font-size: 14px !important;
          line-height: 1 !important;
          text-transform: uppercase !important;
          width: auto!important;
        }
        .account__header-content {
          padding-inline: 0!important;
          gap: 20px!important;
        }

        .account-close-label {
          display: inline-block;
        }

        .stack-inline {
          gap: 20px !important;
        }

        .stack-inline .button {
          padding: 6px 40px;
          font-size: 16px;
          line-height: 18px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: black;
          border: none !important;
          min-height: auto !important;
          color: #F6F3E1;
          overflow: hidden;
          box-shadow: none;
          clip-path: polygon(
            6px 0%,
            calc(100% - 6px) 0%,
            100% 6px,
            100% calc(100% - 6px),
            calc(100% - 6px) 100%,
            6px 100%,
            0% calc(100% - 6px),
            0% 6px
          );
          transition:
            padding 0.6s cubic-bezier(0.22, 1, 0.36, 1),
            margin 0.6s cubic-bezier(0.22, 1, 0.36, 1),
            background 0.3s ease;
        }

        .stack-inline .button:hover {
          background: #173326;
        }

        .cta-roll__label {
          position: relative;
          display: inline-grid;
          overflow: hidden;
        }

        .cta-roll__text {
          grid-area: 1 / 1;
          transition: transform 0.45s cubic-bezier(0.65, 0.05, 0, 1);
          will-change: transform;
        }

        .cta-roll__text--hover {
          transform: translateY(110%);
        }

        .stack-inline .button:hover .cta-roll__text:not(.cta-roll__text--hover) {
          transform: translateY(-110%);
        }

        .stack-inline .button:hover .cta-roll__text--hover {
          transform: translateY(0);
        }

        .account {
          height: -webkit-fit-content !important;
          height: fit-content !important;
        }

        @media (width < 48rem) {
          .account-custom-label {
            font-size: 30px;
          }

          .dialog {
            margin-inline: 16px !important;
            width: auto !important;
          }
        }
        @media (width >= 120rem) {
          .account-custom-label {
            font-size: 22px;
          }
        }
      `;

      root.appendChild(style);
    }

    if (!root.__accountDialogObserver) {
      root.__accountDialogObserver = new MutationObserver(() => {
        patchDialog(root);
        patchLoginForm(root);
        syncAccountScrollLock();
      });

      root.__accountDialogObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['open']
      });
    }

    syncAccountScrollLock();

    el.classList.add('ready');
  }

  patchButton();

  if (!el.__accountObserver) {
    el.__accountObserver = new MutationObserver(() => {
      patchButton();
      syncAccountScrollLock();
    });

    el.__accountObserver.observe(el, {
      childList: true,
      subtree: true
    });
  }
}

customElements.whenDefined('shopify-account').then(() => {
  document.querySelectorAll('shopify-account').forEach(patchShopifyAccount);

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.tagName === 'SHOPIFY-ACCOUNT') {
          patchShopifyAccount(node);
        }

        node.querySelectorAll?.('shopify-account').forEach(patchShopifyAccount);
      });
    });

    syncAccountScrollLock();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* Section collection home */
(() => {
  function initCollectionTabs() {
    const collectionItems = [...document.querySelectorAll('.collection-item')];

    if (!collectionItems.length) return;

    const groups = new Map();

    collectionItems.forEach((item) => {
      const outerBlock = item.closest('[data-testid="group-block"]');
      const groupParent = outerBlock?.parentElement;

      if (!groupParent) return;

      if (!groups.has(groupParent)) {
        groups.set(groupParent, []);
      }

      groups.get(groupParent).push(item);
    });

    groups.forEach((items, groupParent) => {
      if (groupParent.dataset.collectionTabsReady === 'true') return;

      groupParent.dataset.collectionTabsReady = 'true';
      groupParent.classList.add('collection-tabs-ready');

      const setActive = (activeItem) => {
        items.forEach((item) => {
          item.classList.toggle('is-active', item === activeItem);
        });

        updateCollectionLayout(activeItem, items, groupParent);
      };

      items.forEach((item, index) => {
        const title = item.querySelector(':scope > rte-formatter h4');

        if (!title) return;

        title.dataset.index = `(${index + 1})`;
        title.dataset.fullText = title.textContent; // salva il testo originale

        title.addEventListener('click', () => {
          setActive(item);
        });
      });

      applyMobileTitles(items);
      setActive(items[0]);
    });
  }

  function applyMobileTitles(items) {
    const isMobile = window.innerWidth < 768; // aggiusta la soglia se necessario

    items.forEach((item) => {
      const title = item.querySelector(':scope > rte-formatter h4');
      if (!title || !title.dataset.index) return;

      title.textContent = isMobile
        ? title.dataset.index
        : title.dataset.fullText;
    });
  }

  function updateCollectionLayout(activeItem, items, groupParent) {
    const title = activeItem.querySelector(':scope > rte-formatter h4');
    const panel = activeItem.querySelector(':scope > .group-block');

    if (!title || !panel || !groupParent) return;

    const parentRect = groupParent.getBoundingClientRect();
    const titleRect = title.getBoundingClientRect();

    const progressWidth = titleRect.left - parentRect.left + titleRect.width;

    groupParent.style.setProperty('--collection-line-progress', `${progressWidth}px`);
    groupParent.style.setProperty('--collection-line-top', `${titleRect.bottom - parentRect.top + 10}px`);
    groupParent.style.setProperty('--collection-content-left', `0px`);
    groupParent.style.setProperty('--collection-content-width', `${parentRect.width}px`);
    groupParent.style.setProperty('--collection-content-top', `${titleRect.bottom - parentRect.top + 30}px`);

    requestAnimationFrame(() => {
      const panelHeight = panel.offsetHeight;
      groupParent.style.setProperty('--collection-tabs-content-height', `${panelHeight + 80}px`);
    });
  }

  initCollectionTabs();

  document.addEventListener('DOMContentLoaded', initCollectionTabs);
  document.addEventListener('shopify:section:load', initCollectionTabs);

  window.addEventListener('resize', () => {
    document.querySelectorAll('.collection-tabs-ready').forEach((groupParent) => {
      const activeItem = groupParent.querySelector('.collection-item.is-active');
      const items = [...groupParent.querySelectorAll('.collection-item')];

      if (activeItem) {
        applyMobileTitles(items); // ricalcola i titoli al resize
        updateCollectionLayout(activeItem, items, groupParent);
      }
    });
  });
})();

/* Funzione per nascondere gli outline se si apre un dialog per ios o safari */
/* function trapFocus(dialog) {
  const FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  function getFocusable() {
    return [...dialog.querySelectorAll(FOCUSABLE)].filter(
      el => !el.closest('[hidden]') && !el.closest('[inert]')
    );
  }

  function handleOpen() {
    if (dialog.querySelector('[autofocus]')) return;

    dialog.setAttribute('tabindex', '-1');
    dialog.focus({ preventScroll: true });

    requestAnimationFrame(() => {
      dialog.removeAttribute('tabindex');
    });
  }

  function handleKeydown(e) {
    if (e.key !== 'Tab') return;

    const focusable = getFocusable();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || active === dialog) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (active === last || active === dialog) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  handleOpen();
  dialog.addEventListener('keydown', handleKeydown);

  function cleanup() {
    dialog.removeEventListener('keydown', handleKeydown);
    dialog.removeEventListener('close', cleanup);
  }

  dialog.addEventListener('close', cleanup);
}
// Osserva tutti i dialog aperti automaticamente
function observeDialogs() {
  // Gestisci i dialog già presenti nel DOM all'avvio
  document.querySelectorAll('dialog[open]').forEach(trapFocus);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      // Dialog aggiunto al DOM già con open
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches('dialog[open]')) trapFocus(node);
        node.querySelectorAll?.('dialog[open]').forEach(trapFocus);
      }

      // Attributo open aggiunto a un dialog esistente
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open' &&
        mutation.target.matches('dialog') &&
        mutation.target.hasAttribute('open')
      ) {
        trapFocus(mutation.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open'],
  });
}
observeDialogs(); */